module.exports = __webpack_public_path__ + "static/min-time-duration2-f1b6f8322c889500ca47d2f313a8f68c.png";